export type CmsRole = "admin" | "editor" | "viewer";
export type AccountStatus = "active" | "suspended";

export const ROLE_LABELS: Record<CmsRole, string> = { admin: "Administrator", editor: "Editor", viewer: "Viewer" };

/** Admin sections and the minimum role required to open them. */
export type Section =
  | "dashboard" | "requests" | "industries" | "blog" | "case-studies" | "news" | "surveys"
  | "survey-responses" | "media" | "partners" | "users" | "access-log" | "legal-review" | "profile"
  | "pricing" | "translations" | "categories" | "integrations" | "system-integrations" | "collections" | "pages";

const ADMIN_ONLY: Section[] = ["requests", "survey-responses", "users", "access-log", "legal-review", "system-integrations"];

export function effectiveRole(role: string | null | undefined, status: string | null | undefined): CmsRole | null {
  if (status === "suspended") return null;
  return role === "admin" || role === "editor" || role === "viewer" ? role : null;
}
export function canOpen(role: CmsRole | null, section: Section): boolean {
  if (!role) return false;
  if (ADMIN_ONLY.includes(section)) return role === "admin";
  return true;
}
export const canEditContent = (role: CmsRole | null) => role === "admin" || role === "editor";
export const canManageUsers = (role: CmsRole | null) => role === "admin";

export function sectionForPath(pathname: string): Section {
  const rest = pathname.replace(/^\/admin\/?/, "");
  if (!rest) return "dashboard";
  if (/^surveys\/[^/]+\/responses/.test(rest)) return "survey-responses";
  return rest.split("/")[0] as Section;
}
/** Pricing is visible to CMS members but only Administrators may change it. */
export const canEditPricing = (role: CmsRole | null) => role === "admin";
